// Re-exported from FilterButtons.jsx, which other files import them from.
// They live here so the toolbar hooks can use them without a circular import.

export const FILTER_BUTTONS_NAMES = {
  RESET_SORT: "Reset Sort",
  REFRESH: "Refresh",
  ALL: "All",
  ADD_OPTION: "Add Option",
  VOL_SURFACE_COMPARISON: "Vol Surface Comparison",
};

export const SUMMARY_IDS = "summaryIds";
